import {
  LOGIN_USER_START,
  USERNAME_CHANGED,
  PASSWORD_CHANGED,
  LOGIN_RESULT,
  CLEAR_SESSION_MODAL,
  LOGOUT_USER,
  SET_SESSION_FROM_STORAGE,
  EXPIRE_SESSION,
  LOGIN_SUCCESS,
  TOGGLE_EVIEW_LOGIN,
  SET_EVIEW_LOGIN,
  SET_PW_CHANGE
} from '../actions/types';

const INITIAL_STATE = {
  username: '',
  password: '',
  loading: false,
  loginResult: '',
  sSess: '',
  isLoggedIn: false,
  useEviewLogin: false,
  sessionEndReason: null,  // { cause, method, url } describing what tripped the last EXPIRE_SESSION
  pwChangeUserId: null     // bID of the user mid forced-password-change (cloud 'changepw' flow)
};

export default function authReducer(state = INITIAL_STATE, action) {
  switch ( action.type ) {
    case USERNAME_CHANGED:
      return { 
        ...state, 
        username: action.payload 
      }
    case PASSWORD_CHANGED:
      return { 
        ...state, 
        password: action.payload 
      }
    case SET_SESSION_FROM_STORAGE:
      return { 
        ...state, 
        sSess: action.payload
      }
    case LOGIN_USER_START:
      return {
        ...state,
        loading: true,
        sessionEndReason: null
      }
    case EXPIRE_SESSION:
      // Session ended — clear the PASSWORD + session, but KEEP the username so the login screen
      // pre-fills it for the re-login (David 2026-08-14: keep username, never the password). The
      // authTransform persists auth, so the kept username survives a reload too. (Auto-login, which
      // used to preserve BOTH for a silent re-login, has been removed.) sessionEndReason carries WHY
      // (the tripping RPC method + URL, or a caller-supplied cause) so the modal can describe it.
      return {
        ...state,
        password: '',
        loading: false,
        loginResult: 'expired',
        sSess: '',
        isLoggedIn: false,
        sessionEndReason: action.reason || null,
        pwChangeUserId: null
      }
    case LOGIN_SUCCESS:
      // Keep loading: true - let the navigation handle the transition
      // loading will be reset on next login attempt or logout
      return {
        ...state,
        loginResult: '',
        loading: true,
        sSess: action.payload,
        isLoggedIn: true,
        pwChangeUserId: null
      }
    case LOGIN_RESULT:
      return { 
        ...state, 
        loginResult: action.payload,
        loading: false
      }
    case LOGOUT_USER:
      // KEEP the username so the login screen pre-fills it next time (redux-persist retains it via the
      // authTransform); clear the password + session + logged-in flag. (David 2026-08-14: keep the
      // username after logout, never the password.)
      return {
        ...state,
        password: '',
        loading: false,
        loginResult: action.payload === 'pwexpired'  ? state.loginResult : '',
        sSess: '',
        isLoggedIn: false,
        pwChangeUserId: null
      }
    case CLEAR_SESSION_MODAL:
      return {
        ...state,
        loginResult: '',
        sessionEndReason: null,
        pwChangeUserId: null
      }
    case TOGGLE_EVIEW_LOGIN:
      return {
        ...state,
        useEviewLogin: !state.useEviewLogin
      }
    case SET_EVIEW_LOGIN:
      return {
        ...state,
        useEviewLogin: action.payload
      }
    case SET_PW_CHANGE:
      // Cloud forced password change: show the change-password screen ('changepw')
      // and hold the user's bID for the /ve/changepassword call. username + password
      // (the temp password just typed) stay in state as the re-login credentials.
      return {
        ...state,
        loginResult: 'changepw',
        pwChangeUserId: action.payload,
        loading: false
      }
    default:
      return state;
  };
};